import { render, staticRenderFns } from "./PaymentItemAmenity.vue?vue&type=template&id=2fd8ba76&scoped=true&"
import script from "./PaymentItemAmenity.vue?vue&type=script&lang=js&"
export * from "./PaymentItemAmenity.vue?vue&type=script&lang=js&"
import style0 from "./PaymentItemAmenity.vue?vue&type=style&index=0&id=2fd8ba76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd8ba76",
  null
  
)

export default component.exports